<template>
<div class="chapter">
<div class="inner_page">
<div id="titlepage">
<p class="center"><img alt="saying grace" src="images/image-120.jpg"/></p>
<h1 class="booktitle">Saying Grace</h1>
<h3 class="subtitle">Blessings <em>for the</em> Family Table</h3>
<p class="author"><em>Edited by</em> Sarah McElwain</p>
<p class="author"><em>Illustrations by</em> David Dean</p>
<p class="publogo"><a href="http://www.chroniclebooks.com" target="_blank"><img alt="Saying Grace Chronicle Books" src="images/logo.jpg"/></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002titlepage.vue?31a66ba3